import Dropdown from "../Dropdown";

interface DocumentPagesFilters {
  status: string;
}

export default function StatusFilter({
  filters,
  handleStatusChange,
}: {
  filters: DocumentPagesFilters;
  handleStatusChange: (value: string) => void;
}) {
  return (
    <>
      {/* Status Filter */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="status"
          className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
        >
          Processing Status
        </label>
        <Dropdown
          id="status"
          value={filters.status}
          onChange={handleStatusChange}
          options={[
            { label: "All Status", value: "" },
            { label: "Done", value: "done" },
            { label: "Pending", value: "pending" },
            { label: "Processing", value: "processing" },
            { label: "Error", value: "error" },
            { label: "Invalid", value: "invalid" },
          ]}
        />
      </div>
    </>
  );
}
